import "./AccountSettings.scss";
import CustomButton from "components/Button/Button";
import { useAppDispatch, useAppSelector } from "store";
import { useCallback } from "react";
import { changePassword } from "../../store/reducers/cabinet";
import { IChangePasswordRequest } from "../../models/cabinet";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Input } from "@mui/base/Input";
import { PASSWORD_REGEXP } from "../../constants/validation";
import { cabinetActions } from "../../store/reducers/cabinet";
import CommonPopup from "components/PopUps/CommonPopup/CommonPopup";

const validationSchema = () => {
  return Yup.object().shape({
    previousPassword: Yup.string().required("Previous password is required"),
    password: Yup.string()
      .matches(PASSWORD_REGEXP, "Password does not meet requirements")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), undefined], "Passwords must match")
      .required("Confirm password is required"),
  });
};

const AccountSettings = () => {
  const dispatch = useAppDispatch();
  const { isOpenPopup } = useAppSelector((state) => state.cabinet);

  const handleClosePopup = useCallback(() => {
    dispatch(cabinetActions.setIsOpenPopup(false));
  }, [dispatch]);
  return (
    <div className="account-settings-container">
      {isOpenPopup && (
        <CommonPopup
          onClick={handleClosePopup}
          header={"Password Changed Successfully"}
          desc={"Your password has been updated."}
        />
      )}

      <div className="setting-title">Change password</div>
      <Formik
        initialValues={{
          previousPassword: "",
          password: "",
          confirmPassword: "",
        }}
        validationSchema={validationSchema}
        onSubmit={async (values, { resetForm, setFieldValue }) => {
          try {
            const response = await dispatch(
              changePassword({
                oldPassword: values.previousPassword,
                newPassword: values.confirmPassword,
              })
            );
            if (
              !Array.isArray(response.payload) &&
              response.payload?.isChanged
            ) {
              resetForm();
            }
          } catch (error) {
            console.error(error);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          isSubmitting,
          isValid,
          handleChange,
          handleBlur,
          setFieldValue,
        }) => {
          return (
            <Form className="signin-form">
              <Input
                name="previousPassword"
                type="text"
                value={values.previousPassword}
                placeholder="Previous password"
                id="previousPassword"
                onChange={handleChange}
                onBlur={(e) => {
                  handleBlur(e);
                  setFieldValue("previousPassword", e.target.value.trim());
                }}
                className={
                  touched.previousPassword && errors.previousPassword
                    ? "error-field"
                    : ""
                }
              />
              <ErrorMessage
                name={"previousPassword"}
                render={(msg) => <div className="error-message">{msg}</div>}
              />
              <Input
                name="password"
                type="text"
                placeholder="Password"
                value={values.password}
                id="password"
                onChange={handleChange}
                onBlur={(e) => {
                  handleBlur(e);
                  setFieldValue("password", e.target.value.trim());
                }}
                className={
                  touched.password && errors.password ? "error-field" : ""
                }
              />
              <ErrorMessage
                name={"password"}
                render={(msg) => <div className="error-message">{msg}</div>}
              />
              <div className="password-requirements">
                <div>Your password should contain:</div>
                <ul>
                  <li>At least 8 or more characters.</li>
                  <li>At least one capital letter (A-Z).</li>
                  <li>At least one lower case letter (a-z).</li>
                  <li>At least one number (0-9).</li>
                </ul>
              </div>
              <Input
                name="confirmPassword"
                type="text"
                placeholder="Confirm password"
                id="confirmPassword"
                value={values.confirmPassword}
                onChange={handleChange}
                onBlur={(e) => {
                  handleBlur(e);
                  setFieldValue("confirmPassword", e.target.value.trim());
                }}
                className={
                  touched.confirmPassword && errors.confirmPassword
                    ? "error-field"
                    : ""
                }
              />
              <ErrorMessage
                name={"confirmPassword"}
                render={(msg) => <div className="error-message">{msg}</div>}
              />
              <CustomButton
                type="submit"
                btnName="Save"
                className="blue-btn"
                disabled={!isValid}
              />
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default AccountSettings;
